import {
  CHANGE_BANNERS_LANGUAGE,
  CHANGE_FIELD,
  MAILBOX_PROTECTION_REQUEST_ASYNC,
  UPDATE_MAILBOX_PROTECTION_REQUEST_ASYNC,
} from './constants'

const getMailboxProtection = () => ({
  type: MAILBOX_PROTECTION_REQUEST_ASYNC.INITIATE,
})
export const getMailboxProtectionSuccess = (data) => ({
  type: MAILBOX_PROTECTION_REQUEST_ASYNC.SUCCESS,
  payload: { data },
})
export const getMailboxProtectionError = (error) => ({
  type: MAILBOX_PROTECTION_REQUEST_ASYNC.ERROR,
  error,
})
const getMailboxProtectionCancel = () => ({
  type: MAILBOX_PROTECTION_REQUEST_ASYNC.CANCEL,
})

const updMailboxProtection = () => ({
  type: UPDATE_MAILBOX_PROTECTION_REQUEST_ASYNC.INITIATE,
})
export const updMailboxProtectionSuccess = (data) => ({
  type: UPDATE_MAILBOX_PROTECTION_REQUEST_ASYNC.SUCCESS,
  payload: { data },
})
export const updMailboxProtectionError = (error) => ({
  type: UPDATE_MAILBOX_PROTECTION_REQUEST_ASYNC.ERROR,
  error,
})
const updMailboxProtectionCancel = () => ({
  type: UPDATE_MAILBOX_PROTECTION_REQUEST_ASYNC.CANCEL,
})

const changeBannersLanguage = (value) => ({
  type: CHANGE_BANNERS_LANGUAGE,
  payload: { value },
})
const changeField = (name, value, selectedLang) => ({
  type: CHANGE_FIELD,
  payload: { name, value, selectedLang },
})

export default {
  // to props
  getMailboxProtection,
  getMailboxProtectionCancel,
  updMailboxProtection,
  updMailboxProtectionCancel,
  changeField,
  changeBannersLanguage,
}
